/* eslint-disable react/display-name */
import * as React from 'react';

import Logo from '~/src/assets/img/img_logo.png';
import KopClub from '~/src/assets/img/img_kop_club.png';

export const AppIcon = {
  Logo: () => <img alt="Kopenhagen logo" src={Logo} width="120px" />,
  KopClub: () => <img alt="Kop Club logo" src={KopClub} width="120px" />,
};
